import { POST } from "../APiHelper/API"

export const getStadiumWeather = (stadium_id, fixture_id, onSuccess, onError) => {
    const data = {
        stadium_id: stadium_id,
        fixture_id: fixture_id,
    }
    POST(`/api/v1/games/stadium_weather`, data, onSuccess, onError)
}